import { render, staticRenderFns } from "./SignInModal.vue?vue&type=template&id=891c3b38"
import script from "./SignInModal.vue?vue&type=script&lang=js"
export * from "./SignInModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports